import React from 'react';
import PropTypes from 'prop-types';
import { Box, Li, Span, Ul, VisuallyHidden } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import TrackingUrlLink from './TrackingUrlLink';

const TrackingDisplayLink = ({ trackingData, productName, itemId }) => {
  const [lineItemMessages] = useTranslations(['lineItemMessages']);
  const trackingLabel = lineItemMessages.tracking;
  const trackingLabelId = `tracking-label-${itemId}`;
  const hasShipments = !!(trackingData && trackingData.length > 0);

  if (hasShipments) {
    return (
      <Box data-testid="tracking-display-link">
        <Ul skin="minimal">
          {trackingData.map(
            shipment =>
              shipment.trackingId &&
              shipment.trackingUrl && (
                <Li key={`tracking-${shipment.trackingId}`}>
                  <Span textColor="subtle" id={trackingLabelId}>
                    {trackingLabel}:{' '}
                    <VisuallyHidden>{`${productName}`}</VisuallyHidden>
                    <TrackingUrlLink
                      itemId={itemId}
                      trackingId={shipment.trackingId}
                      trackingUrl={shipment.trackingUrl}
                    />
                  </Span>
                </Li>
              )
          )}
        </Ul>
      </Box>
    );
  }

  return null;
};

TrackingDisplayLink.propTypes = {
  trackingData: PropTypes.arrayOf(
    PropTypes.shape({
      trackingId: PropTypes.string.isRequired,
      trackingUrl: PropTypes.string.isRequired,
    })
  ),
  productName: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
};

export default TrackingDisplayLink;
